import type { ButtonHTMLAttributes } from 'react';

import { Typography } from 'src/app/components/Elements/Typography';

import { RadioCircle, RadioInput, RadioLabel } from './styles';

interface RadioProps {
  isActive: boolean;
  label: string;
  onClick: ButtonHTMLAttributes<HTMLLabelElement>['onClick'];
  id: string;
}

export const Radio = ({ isActive, label, onClick, id }: RadioProps) => {
  return (
    <RadioLabel htmlFor={id} onClick={onClick}>
      <Typography variant={'body'}>{label}</Typography>
      <RadioInput id={id} type="radio" name="radio" value={id} />
      <RadioCircle isActive={isActive} />
    </RadioLabel>
  );
};
